import React from "react";

const LeftArrowNoTail = ({ width = 24, height = 24 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M10.6858 12.0705L15.6358 7.12049C15.818 6.93189 15.9187 6.67929 15.9165 6.41709C15.9142 6.1549 15.809 5.90408 15.6236 5.71867C15.4382 5.53327 15.1874 5.4281 14.9252 5.42582C14.663 5.42354 14.4104 5.52434 14.2218 5.70649L8.56479 11.3635C8.37732 11.551 8.27201 11.8053 8.27201 12.0705C8.27201 12.3357 8.37732 12.59 8.56479 12.7775L14.2218 18.4345C14.4104 18.6167 14.663 18.7174 14.9252 18.7152C15.1874 18.7129 15.4382 18.6077 15.6236 18.4223C15.809 18.2369 15.9142 17.9861 15.9165 17.7239C15.9187 17.4617 15.818 17.2091 15.6358 17.0205L10.6858 12.0705Z"
        fill="#1A325D"
      />
    </svg>
  );
};

export default LeftArrowNoTail;
